module.exports = __webpack_public_path__ + "img/P4-zh.abb80f30.png";